export default __webpack_public_path__ + "static/article-time-to-renovate-your-bathroom-4a26a4a5c05bfd65dc94670ae68ae096.jpg";